import moment from "moment";
import { orderAheadStatusLabel } from "./orderAheadOrder";

export interface OrderAheadOrderRow {
  id: number;
  reference_id: string;
  created_at: string;
  subtotal: number;
  tax: number;
  tip: number;
  digital_surcharge: number;
  status: string;
  expo_status: string;
  email: string;
  phone_number: string;
  processor_ref_id: string;
  event: { name: string } | null;
  vendor: { name: string } | null;
  location: { name: string } | null;
}

const escape = (v: unknown): string => {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (s.includes(",") || s.includes('"') || s.includes("\n")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

const fmtDate = (iso?: string) => (iso ? moment.utc(iso).format("MM/DD/YYYY h:mm a") : "");
const fmtMoney = (cents?: number) => ((cents ?? 0) / 100).toFixed(2);

export const exportOrderAheadOrdersCsv = (orders: OrderAheadOrderRow[]) => {
  const headers = [
    "Order ID",
    "Reference ID",
    "Date",
    "Subtotal",
    "Tax",
    "Tip",
    "Service Fee",
    "Total",
    "Status",
    "Expo Status",
    "Email",
    "Phone",
    "Processor Ref ID",
    "Location",
    "Vendor",
    "Event",
  ];
  const rows: string[][] = [headers];

  orders.forEach((o) => {
    const total =
      (o.subtotal ?? 0) + (o.tax ?? 0) + (o.tip ?? 0) + (o.digital_surcharge ?? 0);
    rows.push([
      String(o.id),
      o.reference_id ?? "",
      fmtDate(o.created_at),
      fmtMoney(o.subtotal),
      fmtMoney(o.tax),
      fmtMoney(o.tip),
      fmtMoney(o.digital_surcharge),
      fmtMoney(total),
      o.status ? orderAheadStatusLabel(o.status) : "",
      o.expo_status ?? "",
      o.email ?? "",
      o.phone_number ?? "",
      o.processor_ref_id ?? "",
      o.location?.name ?? "",
      o.vendor?.name ?? "",
      o.event?.name ?? "",
    ]);
  });

  const csv = rows.map((r) => r.map(escape).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const timestamp = new Date().toISOString().replace(/[-:]/g, "").split(".")[0];
  a.download = `OrderAheadOrders_${timestamp}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
